<template>
  <div class="col c309 p-0 m-0">
    <m-a v-if="imageLink!=null" :target="linkTarget" :href="imageLink">
      <img :src="image" :alt="alt" class=" c309-image p-0 m-0">
    </m-a>
    <m-img :src="image" :alt="alt" class=" c309-image p-0 m-0" v-else/>
    <div class="c309-text" data-slot="default">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import mImg from '../Tags/Img'
import mA from '../Tags/A'
import {CardProps} from "./CardProps";

export default {
  name: "C309",
  components: {mImg, mA},
  props: {
    ...CardProps
  }
}
</script>

<style scoped>
.c309 {
  height: 450px;
}

.c309-image {
  height: 280px;
  width: 100%;
  aspect-ratio: 1/1;
  object-fit: contain;
}

</style>